import { useMemo } from 'react';
import { PartnerSearchResponse, ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { PartnerType } from 'types';

function useFilteredPartners(partners: PartnerSearchResponse[], serviceAgreement: ServiceAgreementV2 | null) {
  return useMemo<PartnerSearchResponse[]>(() => {
    if (!serviceAgreement || partners.length === 0) {
      return [];
    }

    switch (serviceAgreement.serviceDefinitionName) {
      case 'ID Delegation':
        return partners.filter((p) => p.partnerType === PartnerType.INDIVIDUAL_PARTNER);
      case 'Third Party Agreement':
      case 'DVP/RVP':
        return partners.filter((p) => p.partnerType === PartnerType.LEGAL_PARTNER);
      default:
        return partners;
    }
  }, [partners, serviceAgreement]);
}

export default useFilteredPartners;
